import validator from "validator";
import { ALLOWED_CHAR_CODES } from "./constants";
import * as punycode from "punycode";
import { isNil, isEmpty } from "ramda";

export const spaces = (txt: string) => {
	return txt && !txt.trim().includes(" ");
};

export const password = (txt: string) => {
	return (
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).+$/.test(txt) &&
		/^(?=.{8,}$)\S+$/i.test(txt)
	);
};

export const required = (txt: any) => {
	const valid = !(isNil(txt) || isEmpty(txt));

	return {
		valid,
		...(!valid && { message: "validation.requiredError" }),
	};
};

export const phone = (txt: string) => {
	if (!txt) return true;
	return txt.match(/^\+?[0-9]+$/) !== null;
};

export function notEmpty(obj: any) {
	return obj !== null && obj !== undefined;
}

export const email = (txt: string) => {
	return txt && validator.isEmail(txt);
};

export const escapedName = (txt: string) => {
	return txt && escapeSpecialCharacters(txt) === txt;
};

export const removeSpaces = (txt: string) => {
	return txt && txt.replace(/\s/g, "");
};

export const onlyNumbers = (txt: string) => {
	if (!txt) return true;
	return txt.match(/^[0-9]+$/) !== null;
};

const escapeSpecialCharacters = (txt: string): string => {
	return escapeString(
		txt.split("").reduce((final, char) => {
			let pointer: number[] = [];

			// if (punycode.ucs2.decode) pointer = punycode.ucs2.decode(char);

			if (pointer[0] < 123 || ALLOWED_CHAR_CODES.includes(char)) {
				final += char;
			}
			return final;
		}, "")
	);
};

const escapeString = (txt: string): string => {
	return txt ? txt.replace(/[\\$'"%#^~|‘“ń]/g, "") : txt;
};

// export function validateData(validations: any, data: any): any {
// 	return Object.keys(validations).reduce((obj: any, key) => {
// 		const reverseArray = reverseArr(validations[key]);
// 		for (let idx in reverseArray) {
// 			const validate = reverseArray[idx].fn;
// 			const disableIf = reverseArray[idx].disableIf;
// 			if (typeof disableIf === "function" && disableIf(data[key], key, data)) {
// 				break;
// 			}
// 			if (!validate(data[key], key, data)) {
// 				obj[key] = reverseArray[idx].msg;
// 			}
// 		}
// 		return obj;
// 	}, {});
// }

// function reverseArr(input: Array<any>) {
// 	let ret = [];
// 	for (let i = input.length - 1; i >= 0; i--) {
// 		ret.push(input[i]);
// 	}
// 	return ret;
// }
